import React from "react";
import { Icons, Button, IconButton, Stack } from "@curves/ui-base";
import { Box } from "@mui/material";
import { isEmpty } from "@util/utils";
import { getInvoiceDisplayInfo } from "@icoach/pos/PosScreenPage.util";

/**
 * 發票設定組件
 * 顯示發票資訊並提供編輯功能
 * @param {Object} props - 組件屬性
 * @param {Object} props.invoiceData - 發票資料
 * @param {Function} props.onEditClick - 編輯按鈕點擊回調
 */
const InvoiceSetting = ({ invoiceData, onEditClick }) => {
	const { title, subtitle } = getInvoiceDisplayInfo(invoiceData);

	return (
		<>
			{isEmpty(invoiceData) ? (
				<Box style={{ padding: "0 14px" }}>
					<Button variant="outlined" size="xsmall" onClick={onEditClick}>
						設定發票
					</Button>
				</Box>
			) : (
				<Stack justifyContent="space-between" alignItems="center">
					<Box className="pos-invoice-display">
						{title && <Box className="invoice-title">{title}</Box>}
						{subtitle && <Box className="invoice-subtitle">{subtitle}</Box>}
					</Box>
					<IconButton
						onClick={onEditClick}
						style={{
							background: "none",
							border: "none",
							padding: "8px",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Icons.Edit
							style={{
								fontSize: "20px",
							}}
						/>
					</IconButton>
				</Stack>
			)}
		</>
	);
};

export default InvoiceSetting;
